import Button from '@/components/ui/button/button'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAppSelector } from '@/redux/hooks'
import { useDialog } from '@/context/dialogContext'
import { buttonName } from '../board/boardItem'
import { useAppDispatch } from '@/redux/hooks'
import { setSearchParams } from '@/redux/slices/golfSearchSlice'
import { useResponsive } from '@/hooks/useResponsive'
import { size } from 'styled-system'

type MenuHeaderProps = {
  pathName: string
  showWriteButton?: boolean //true면 글쓰기, 목록 버튼 path에 따라서 바뀜
  loginRequired?: boolean
  iconActive?: boolean
  menuInfoRef: React.RefObject<HTMLDivElement> // Receive the ref from the parent
  isMobile?: boolean
}

const titleMap: Record<string, string> = {
  '/about': '꿀프소개',
  '/golf/detailSearch': '꿀프장검색',
  '/youtube': '꿀플루언서',
  '/feedback': '목소리',
  '/survey': '투표',
  '/blog': '소통',
  '/promotion': '정보',
  '/inquiry': '문의',
  '/notice': '공지사항',
}

export const MenuHeader: React.FC<MenuHeaderProps> = ({
  pathName,
  showWriteButton,
  loginRequired,
  iconActive,
  menuInfoRef,
}) => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const { showAlert } = useDialog()
  const [title, setTitle] = useState('')
  const writePath =
    showWriteButton && loginRequired && !isAuthenticated
      ? '/login'
      : `${pathName}/write`

  const handleIconClick = () => {
    if (menuInfoRef.current) {
      menuInfoRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }
  }

  const dispatch = useAppDispatch()

  useEffect(() => {
    // 타이틀 설정
    const matchedPath = Object.keys(titleMap).find((key) =>
      pathName.startsWith(key),
    )
    if (matchedPath) {
      setTitle(titleMap[matchedPath])
    }

    // 검색 파라미터 초기화
    if (pathName === '/' || pathName === '/detailSearch') {
      dispatch(
        setSearchParams({
          bizNm: null,
          maxPrice: null,
          areaCd: null,
          dayType: 'weekday',
          months: null,
          membershipYn: 'A',
          holeType: '',
          confidenceLvlCd: '',
        }),
      )
    }
  }, [pathName, dispatch])
  // useEffect(() => {
  //   const matchedPath = Object.keys(titleMap).find((key) =>
  //     pathName.startsWith(key),
  //   )
  //   if (matchedPath) {
  //     setTitle(titleMap[matchedPath])
  //   }
  // }, [pathName])

  // useEffect(() => {
  //   if (pathName === '/') {
  //     dispatch(
  //       setSearchParams({
  //         bizNm: null,
  //         maxPrice: null,
  //         areaCd: null,
  //         dayType: 'weekday',
  //         months: null,
  //         membershipYn: 'A',
  //         holeType: '',
  //         confidenceLvlCd: '',
  //       }),
  //     )
  //   } else if (pathName === '/detailSearch') {
  //     dispatch(
  //       setSearchParams({
  //         bizNm: null,
  //         maxPrice: null,
  //         areaCd: null,
  //         dayType: 'weekday',
  //         months: null,
  //         membershipYn: 'A',
  //         holeType: '',
  //         confidenceLvlCd: '',
  //       }),
  //     )
  //   }
  // }, [pathName, dispatch])

  const createPost = () => {
    if (!isAuthenticated && loginRequired) {
      showAlert({
        title: '로그인 후 글 작성이 가능해요.',
        btnName: buttonName.confirm,
        onClose() {
          navigate('/login')
        },
      })
      return
    }
    navigate(writePath)
  }

  const isDetailOrWrite = /\/(write|detail)/.test(pathName)

  const handleButtonClick = () => {
    if (isDetailOrWrite) {
      const basePath = pathName.replace(/\/(write|detail.*)$/, '')
      navigate(basePath || '/')
    } else {
      createPost()
    }
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: '10px',
        alignItems: 'center',
        marginTop: '20px',
      }}
    >
      <div style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
        <div
          style={{
            textAlign: 'center',
            fontSize: '20px',
            cursor: 'pointer',
            fontWeight: 'bold',
          }}
          onClick={() => navigate(0)}
        >
          {title}
        </div>
        {/* {isMobile && pathName === '/survey' && (
          <p style={{ fontSize: '12px', color: 'red' }}>
            투표현황/결과는 PC화면에서 확인 가능해요.
          </p>
        )} */}
        {iconActive && (
          <img
            src="/svg/question-mark-circle-outline-icon.svg"
            alt="caution"
            width={15}
            height={15}
            onClick={handleIconClick}
            style={{ cursor: 'pointer' }}
          />
        )}
      </div>
      {showWriteButton && (
        <Button color="neverbe" onClick={handleButtonClick}>
          {isDetailOrWrite ? '목록' : '글쓰기'}
        </Button>
      )}
    </div>
  )
}
